import $ from 'jquery';
import abTestService from '../services/abTestService';

const PAYMENT_INSTALLMENTS_VARIATION_NAMES = ['showPaymentInstallmentsInfo_no', 'showPaymentInstallmentsInfo_yes'],

    initPaymentInstallmentsTestForArrangementPage = () => {
        const $showPayableInInstallments = $('.showPayableInInstallments');

        abTestService.whenAssignmentsReady()
            .then(() => {
                const testName = abTestService.getActiveTestName(PAYMENT_INSTALLMENTS_VARIATION_NAMES);

                if (testName && $showPayableInInstallments.length) {
                    abTestService.sendImpression(testName);
                }
            })
            .catch(console.error);

        $('.packages-table .package-bookBtn').on(
            'mousedown',
            () => {
                abTestService.sendEventWhenAssignmentsReady(
                    PAYMENT_INSTALLMENTS_VARIATION_NAMES,
                    'ticketCategorySelect'
                ).catch(console.error);
            }
        );
    },

    initPaymentInstallmentsTestForArrangementList = () => {
        const $filteredArrangementsContainer = $('.filteredArrangementsContainer'),
            $showPayableInInstallments = $('.showPayableInInstallments');

        if (!$filteredArrangementsContainer.length) {
            return;
        }

        abTestService.whenAssignmentsReady()
            .then(() => {
                const testName = abTestService.getActiveTestName(PAYMENT_INSTALLMENTS_VARIATION_NAMES);

                if (testName && $showPayableInInstallments.length) {
                    abTestService.sendImpression(testName);
                }
            })
            .catch(console.error);

        $filteredArrangementsContainer.on(
            'mousedown',
            '.arrangementListItem-matchName, .arrangementListItem-logos-wrapper, .bookBtn',
            () => {
                abTestService.sendEventWhenAssignmentsReady(
                    PAYMENT_INSTALLMENTS_VARIATION_NAMES,
                    'arrangementLinkClicked'
                ).catch(console.error);
            }
        );
    },

    initPaginatorVsLoadMoreBtnTest = () => {
        const variationNames = ['showLoadMoreButton_no', 'showLoadMoreButton_yes'];

        abTestService.sendEventWhenAssignmentsReady(variationNames, 'openClubPage').catch(console.error);
        $('.paginationBlockContainer').on('click', '.page-link', () => {
            abTestService.sendEventWhenAssignmentsReady(
                variationNames,
                'clickedOnPaginatorElement'
            ).catch(console.error);
        });
    },

    initStayMinimumNightsInfoTest = () => {
        const stayInfo = document.querySelector('.highlightedStayInfo');
        
        if (!stayInfo) {
            return;
        }

        const testName = abTestService.getActiveTestName(
            ['improvedStayMinimumNightsInfo_no', 'improvedStayMinimumNightsInfo_yes']
        );

        if (!testName) {
            return;
        }

        abTestService.sendImpression(testName);
        abTestService.sendEvent(testName, 'storefront_minimum_nights_info_showed');

        const trackInteraction = (isWidget = false) => {
            const eventName = isWidget
                ? 'storefront_minimum_nights_info_viewed_widget'
                : 'storefront_minimum_nights_info_viewed_header';

            abTestService.sendEvent(testName, eventName);
        };

        if (document.querySelector('button.highlightedStayInfo[data-bs-target="#stayMinimumNightsInfoModal"]')) {
            const modalElement = document.getElementById('stayMinimumNightsInfoModal');

            if (modalElement) {
                modalElement.addEventListener('shown.bs.modal', (event) => {
                    trackInteraction(event.relatedTarget && event.relatedTarget.classList.contains('inWidget'));
                });
            }
        } else {
            document.addEventListener('shown.bs.popover', (event) => {
                if (event.target.classList.contains('highlightedStayInfo') && event.target.dataset.bsToggle === 'popover') {
                    trackInteraction(event.target.classList.contains('inWidget'));
                }
            });
        }
    };

export {
    initPaymentInstallmentsTestForArrangementList,
    initPaymentInstallmentsTestForArrangementPage,
    initPaginatorVsLoadMoreBtnTest,
    initStayMinimumNightsInfoTest
};